<!--
@Author: MIYONGLE
@Desc: 侧导航
@Date: 2021-04-21 11时
-->
<template>
  <div class="side-bar">
    <!-- 免费体验 -->
    <span class="side-bar-text" @click="sendMsg"
      >免<br />费<br />体<br />验</span
    >

    <!-- 合作资讯 -->
    <div class="side-bar-hezuo">
      <span class="side-bar-text">合<br />作<br />咨<br />询</span>
      <div>
        <span>
          <i>咨询热线</i>
          <i>400-085-5500</i>
        </span>

        <span>
          <i>联系邮箱</i>
          <i>market@hvyogo.com</i>
        </span>
      </div>
    </div>

    <!-- 二维码 -->
    <div class="ewm-con">
      <span class="ewm-btn">
        <img src="../../static/pc/icon_code.png" alt="慧用工" />
      </span>

      <!-- 公众号 -->
      <div class="qr_code">
        <div>
          <img src="../../static/pc/footer_img_wechat.png" alt="" />
          <span>慧用工公众号</span>
        </div>
        <div>
          <!-- v-if="setting == 'production'" -->
          <img src="../../static/pc/footer_img_wechat_dl.png" alt="" />
          <!-- <img v-else src="../../static/mobile/test.png" alt="" /> -->
          <span>代理助手小程序</span>
        </div>
      </div>
    </div>

    <!-- 箭头 -->
    <span class="cursor-btn" @click="scrollMth()">
      <img src="../../static/pc/icon_top.png" alt="" />
    </span>
  </div>
</template>

<script type="text/javascript">
import {
  getSession,
  jumpIndexPagePoin,
  jumpAnchorPoint
} from "../filters/filters";
export default {
  name: "side-bar",
  data() {
    return {
      setting:'',
    };
  },

  inject: ["reload"], // 引入刷新方法

  components: {},

  created() {
    this.setting =  process.env.NODE_ENV
  },

  mounted() {},

  methods: {
    //获取滚动条的高度
    scrollMth() {
      jumpAnchorPoint("#menuNav");
    },

    // 兄弟传值
    sendMsg() {
      eventBus.$emit("pcOperaDiaLog", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.side-bar {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 99;
  .side-bar-text {
    height: 110px;
    width: 66px;
    font-size: 16px;
    color: #ffffff;
    line-height: 20px;
    font-family: PingFangSC-Medium;
    display: block;
    text-align: center;
    background: #1985ff;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
    margin-top: 16px;
    border-radius: 10px;
    padding-top: 15px;
    cursor: pointer;
  }

  //合作资讯
  .side-bar-hezuo:hover {
    div {
      display: block;
    }
  }
  .side-bar-hezuo {
    position: relative;
    cursor: pointer;

    div {
      padding: 27px 10px 27px 24px;
      box-sizing: border-box;
      width: 286px;
      height: 170px;
      background: #fff;
      box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      position: absolute;
      top: -26px;
      display: none;
      right: 85px;
      &::after {
        content: " ";
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 16px solid #fff;
        border-bottom: 12px solid transparent;
        position: absolute;
        right: -12px;
        top: 70px;
      }
      span {
        display: block;
        text-align: left;
        i {
          font-style: normal;
          display: block;
          text-align: left;
          font-size: 14px;
          color: #78818c;
        }
      }

      span:nth-child(1) {
        i:nth-child(1)::before {
          content: " ";
          display: inline-block;
          height: 22px;
          width: 22px;
          background: url("../../static/pc/ic_home_phone.png") no-repeat center;
          background-size: 100%;
          margin-right: 20px;
          position: relative;
          top: 5px;
        }

        i:nth-child(2) {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #1985ff;
          margin-top: 4px;
          margin-left: 42px;
        }
      }
      span:nth-child(2) {
        i:nth-child(1)::before {
          content: " ";
          display: inline-block;
          height: 22px;
          width: 22px;
          background: url("../../static/pc/ic_home_mail.png") no-repeat center;
          background-size: 100%;
          margin-right: 20px;
          position: relative;
          top: 5px;
        }
        i:nth-child(2) {
          font-size: 18px;
          color: #403f3f;
          margin-top: 4px;
          margin-left: 42px;
        }
      }
    }
  }

  //二维码
  .ewm-con:hover {
    .qr_code {
      display: block;
    }
  }
  .ewm-con {
    position: relative;
    cursor: pointer;
    .qr_code {
      width: 310px;
      height: 170px;
      padding: 14px 20px 11px 26px;
      justify-content: center;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      position: absolute;
      top: -33px;
      right: 85px;
      display: none;
      &::after {
        content: " ";
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-left: 16px solid #fff;
        border-bottom: 12px solid transparent;
        position: absolute;
        right: -12px;
        top: 50%;
        transform: translate(0,-50%);
      }
      div {
        width: 120px;
        float: left;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:nth-child(1) {
          margin-right: 18px;
        }
        img {
          display: block;
          width: 100%;
          height: 120px;
        }
        span {
          display: block;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #78818c;
        }
      }
    }

    .ewm-btn {
      width: 66px;
      height: 66px;
      background: #1985ff;
      box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      display: block;
      cursor: pointer;
      margin-top: 16px;
      img {
        text-align: center;
        margin-top: 23px;
      }
    }
  }

  //箭头
  .cursor-btn {
    background: #ffffff;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    display: block;
    width: 66px;
    height: 66px;
    margin-top: 16px;
    cursor: pointer;
    img {
      text-align: center;
      margin-top: 21px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sideBar.vue